import { render, staticRenderFns } from "./CashflowCategoryNotification.vue?vue&type=template&id=23c55d28&scoped=true&"
import script from "./CashflowCategoryNotification.vue?vue&type=script&lang=js&"
export * from "./CashflowCategoryNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c55d28",
  null
  
)

export default component.exports